export default __webpack_public_path__ + "static/media/red_fescue.7dbf24c1.jpeg";